let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("csvSn")).then(() => parcelRequire('crIJ2'));